import { Link } from 'react-router-dom';
import type { ContentItem } from '@/lib/content';
import ContentCard from '@/components/feature/ContentCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function StoryHighlights({ items }: { items: ContentItem[] }) {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
      <SectionHeading
        eyebrow="STORY"
        title="剧情精选：从雨夜那一扇门说起"
        description="按时间线整理的十二集剧情脉络，每一幕都标注了关键场景与人物关系的变化。你可以从任意一幕开始读，也可以从头顺着走一遍。"
        moreTo="/story"
        moreLabel="查看全部剧情"
      />
      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item, index) => (
          <ContentCard key={item.id} item={item} index={index} />
        ))}
      </div>
      <div className="mt-8 flex flex-col gap-3 rounded-lg border border-background-200/70 bg-background-100 p-5 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-foreground-400">
          <i className="ri-quill-pen-line mr-2 text-primary-400"></i>
          剧集共 12 集，本站按"幕"整理为 9 个剧情节点，覆盖从重逢到杀青的完整情绪线。
        </p>
        <Link
          to="/story"
          className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500/40 px-4 py-2 text-sm text-primary-300 transition-colors hover:bg-primary-500/10"
        >
          查看剧情目录
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}